import { ButtonBase, Typography } from '@mui/material';
import React from 'react';

export interface ExpandableHeaderToggleLabelProps {
  children: React.ReactNode;
  onClick: () => void;
}

/**
 * ExpandableHeaderToggleLabel renders the clickable label for expandable header content.
 * @param props - Label content and click handler.
 * @returns A small typography toggle label.
 */
export const ExpandableHeaderToggleLabel = ({
  children,
  onClick,
}: ExpandableHeaderToggleLabelProps) => (
  <ButtonBase component="span" disableRipple onClick={onClick}>
    <Typography variant="bodySmall">{children}</Typography>
  </ButtonBase>
);
